'use client';

import { PropsWithChildren } from 'react';

import { withGuard } from '@/helpers/hocs';
import { useCommonStore } from '@/store';

function MobileAppPage({ children }: PropsWithChildren) {
  return children;
}

export default withGuard(MobileAppPage, {
  checkIsHiddenPage: () => {
    const mobileAppCMS = useCommonStore.use.mobileAppCMS();

    return !mobileAppCMS;
  },
  redirectUrl: '/',
  userGroups: [],
  showIfNotAuthenticated: true,
});
